import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Box from 'ui-box';
import AntdAlertErrorBoundary from '../../components/common/AntdAlertErrorBoundary';
import MobileHeader from '../../components/mobile/Header';
import MedicalHistoryHomeScreen from '../../pages/mobile/medical-history/MedicalHistoryHomeScreen';
import AlergiesScreen from  '../../pages/mobile/medical-history/AlergiesScreen';
import MedicalConditionScreen from  '../../pages/mobile/medical-history/MedicalConditionScreen';
import MedicationsScreen from  '../../pages/mobile/medical-history/MedicationsScreen';
import FamilyHistoryScreen from  '../../pages/mobile/medical-history/FamilyHistoryScreen';
import MeasurementsScreen from  '../../pages/mobile/medical-history/MeasurementsScreen';

function MobileMedicalHistoryLayout() {

  return (
    < >
      <Box position="relative">
        <AntdAlertErrorBoundary>
          <MobileHeader />
        </AntdAlertErrorBoundary>
        <AntdAlertErrorBoundary>
          <Box paddingTop={24} paddingBottom={12} paddingX={20} marginBottom={40}>
            <Switch>
              <Route path="/medical-history/alergies">
                <AlergiesScreen />
              </Route>
              <Route path="/medical-history/medical-condition">
                <MedicalConditionScreen />
              </Route>
              <Route path="/medical-history/medication">
                <MedicationsScreen />
              </Route>
              <Route path="/medical-history/family-history">
                <FamilyHistoryScreen />
              </Route>
              <Route path="/medical-history/measurements">
                <MeasurementsScreen />
              </Route>
              <Route path="/medical-history">
                <MedicalHistoryHomeScreen />
              </Route>
            </Switch>
          </Box>
        </AntdAlertErrorBoundary>
      </Box>
    </>
  );
}

export default MobileMedicalHistoryLayout;
